function getDataLayer(): Record<string, unknown>[] | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as { dataLayer?: Record<string, unknown>[] }).dataLayer
}

export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 100] as const
export type ScrollDepthPercent = (typeof SCROLL_DEPTH_THRESHOLDS)[number]

export interface GTMScrollDepthPayload {
  event: 'scroll_depth'
  scroll_depth_percent: ScrollDepthPercent
  page_path?: string
  page_title?: string
  page_location?: string
}

export function pushScrollDepthToDataLayer(
  percent: ScrollDepthPercent,
  pathname?: string,
): void {
  const dataLayer = getDataLayer()
  if (!dataLayer) return

  dataLayer.push({
    event: 'scroll_depth',
    scroll_depth_percent: percent,
    page_path: pathname ?? (typeof window !== 'undefined' ? window.location.pathname : undefined),
    page_title: typeof document !== 'undefined' ? document.title : undefined,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
  } as unknown as Record<string, unknown>)
}
